// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle {
	position: relative;
	display: inline-block;
	width: 50px;
	height: 26px;
	background-color: #d9d9d9;
	border-radius: 30px;
	border: 0px solid rgba(128, 128, 128, 0);
}

.toggle::after {
	content: '';
	position: absolute;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background-color: rgb(255, 255, 255);
	top: 0px;
	left: 0px;
	transition: all 0.5s;
}

.checkbox:checked + .toggle::after {
	transform: translateX(26px);
}

.checkbox:checked + .toggle {
	background-color: #b7d423;
}

.checkbox {
	display: none;
}
@media screen and (max-width: 770px) {
	.toggle {
		width: 40px;
		height: 21px;
	}
	.toggle::after {
		width: 21px;
		height: 21px;
	}
	.checkbox:checked + .toggle::after {
		transform: translateX(21px);
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Switch/switch.styles.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,wCAAwC;AACzC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,oCAAoC;CACpC,QAAQ;CACR,SAAS;CACT,oBAAoB;AACrB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".toggle {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 50px;\n\theight: 26px;\n\tbackground-color: #d9d9d9;\n\tborder-radius: 30px;\n\tborder: 0px solid rgba(128, 128, 128, 0);\n}\n\n.toggle::after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 26px;\n\theight: 26px;\n\tborder-radius: 50%;\n\tbackground-color: rgb(255, 255, 255);\n\ttop: 0px;\n\tleft: 0px;\n\ttransition: all 0.5s;\n}\n\n.checkbox:checked + .toggle::after {\n\ttransform: translateX(26px);\n}\n\n.checkbox:checked + .toggle {\n\tbackground-color: #b7d423;\n}\n\n.checkbox {\n\tdisplay: none;\n}\n@media screen and (max-width: 770px) {\n\t.toggle {\n\t\twidth: 40px;\n\t\theight: 21px;\n\t}\n\t.toggle::after {\n\t\twidth: 21px;\n\t\theight: 21px;\n\t}\n\t.checkbox:checked + .toggle::after {\n\t\ttransform: translateX(21px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
